<template lang="html">
	<td
		ref="cell"
		v-bind="$attrs"
		class="om-table-cell"
		:class="{ 'om-table-cell-has-checkbox': hasCheckbox }"
		:colspan="colspan"
	>
		<!-- @slot Cell Content -->
		<slot></slot>
	</td>
</template>

<script lang="js">
/**
 * Table Cell
 *
 * @since 2.0.0
 */
export default {
	props: {
		/**
		 * Whether this cell has the checkbox.
		 *
		 * @type {boolean}
		 */
		hasCheckbox: Boolean,
		colspan: {
			type: Number,
			default: 1,
		},
	},
};
</script>

<style scoped lang="scss">
.om-table-cell-has-checkbox {
	padding: 8px 10px;

	input[type='checkbox'] {
		margin: 0 0 0 8px;
	}
}
</style>
